import { Analytics } from 'utils/analytics/types'

export const ANALYTICS: Analytics = {}
